<template><!--个人中心》我的余额》充值-->
    <div class="userRecharge">
        <div class="mybal-box">
            <div class="userrec-wid dis-between" style="padding:0 24px">
                <div>充值账号：{{account}}</div>
                <div class="dis">
                    <img class="userrec-img" src="../../../assets/image/iocn/yue.png" />
                    <div>当前余额：¥ {{myBalance.balance}}</div>
                </div>
            </div>
        </div>
        <div class="mybal-box" style="padding:0 24px 24px 24px">
            <div class="dis">
                <div  @click="valueClick(1)">
                    <div class="userrec-box" :class="type == 1?'userrec-act-bor':''">¥ 50</div>
                    <div class="userrec-img2 dis-end" style="width:160px"><img v-if="type == 1" src="../../../assets/image/iocn/gouxuan.png" /></div>
                </div>
                <div  @click="valueClick(2)">
                    <div class="userrec-box" :class="type == 2?'userrec-act-bor':''">¥ 100</div>
                    <div class="userrec-img2 dis-end" style="width:160px"><img v-if="type == 2" src="../../../assets/image/iocn/gouxuan.png" /></div>
                </div>
                <div  @click="valueClick(3)">
                    <div class="userrec-box" :class="type == 3?'userrec-act-bor':''">¥ 200</div>
                    <div class="userrec-img2 dis-end" style="width:160px"><img v-if="type == 3" src="../../../assets/image/iocn/gouxuan.png" /></div>
                </div>
                <div  @click="valueClick(4)">
                    <div class="userrec-box" :class="type == 4?'userrec-act-bor':''">
                        <div class="dis" style="width:60%;margin:0 auto">
                            <div class="userrec-color" :class="type == 4?'userrec-act-color':''">¥</div>
                            <input type="text" v-if="type != 4" class="userrec-input" v-model="value" placeholder="其它金额" style="width:81%;font-size: 18px;" />
                            <input type="number" v-else class="userrec-input" v-model="value" />
                        </div>
                    </div>
                    <div class="userrec-img2 dis-end" style="width:160px"><img v-if="type == 4" src="../../../assets/image/iocn/gouxuan.png" /></div>
                </div>
            </div>
            <!-- <div v-if="!is_butClick" class="withdra-color withdra-but" @click="immediatePay" style="margin:48px 0 24px 0">确认充值</div>
            <div v-else class="withdra-color withdra-but" style="margin:48px 0 24px 0;background:#cacaca">加载中...</div> -->
            <div class="withdra-color withdra-but" style="margin:48px 0 24px 0;background:#484848">确认充值</div>
        </div>

        <!----------------------------------------------------------->

        <div class="orderpay" v-show="payFlagPapup">
            <div class="pay-code-box">
                <div class="pay-code-content">
                    <div class="pay-code-top">
                        <p>付款</p>
                        <p @click="closeCodePapup">×</p>
                    </div>
                    <div class="pay-code-price">
                        金额:
                        <span v-if="set_value > 0">￥{{set_value}}</span>
                        <span v-else>￥{{value}}</span>
                    </div>
                    <div class="pay-code-tips">请使用以下支付方式扫码付款</div>
                    <div class="paytype-item">
                        <img src="../../../assets/image/img/购物车/sub-gs.png" alt />
                        <img src="../../../assets/image/img/购物车/sub-wx.png" alt />
                        <img src="../../../assets/image/img/购物车/sub-zfb.png" alt />
                    </div>
                    <div style="text-align:center">
                        <vue-qr :text="qr_text" :size="150" />
                    </div>
                    <div class="success-btn" @click="pay_success">支付完成</div>
                </div>
            </div>
        </div>

    </div>
</template>

<style scoped>
    input:focus{outline:medium;}
    .userrec-wid{width:100%;line-height:56px;background: #F1F1F1;font-size: 18px;padding-left:24px;font-family: PingFang SC;font-weight: 500;color: #434343;line-height: 56px;}
    .userrec-img{width:24px;height:26px;margin:auto 0;margin-right:23px}
    .userrec-box{text-align: center;font-size: 22px;font-family: PingFang SC;font-weight: 500;color: #999999;line-height: 78px;width: 160px;height:80px;border:1px solid #CACACA;cursor: pointer;margin-right: 24px;}
    .userrec-act-bor{border: 2px solid #11D165;color:#11D165}.userrec-color{color: #999999;}.userrec-act-color{color: #11D165;}
    .userrec-img2{position: relative;top:-26px;z-index: 3;}
    .userrec-input{width:80%;margin:auto 0 auto 5%;height:30px;border:none;color:#11D165;font-size: 22px;}
    /***************************************************** */
    .orderpay {
	width: 100%;
	height: 100%;
	position: fixed;
	top: 0;
	left: 0;
	z-index: 5;
}

.paysuccess {
	width: 9.375rem;
	height: 1.875rem;
	border-radius: 5px;
	text-align: center;
	font-size: 0.875rem;
	font-weight: 400;
	color: #ffffff;
	background-color: #37a115;
	margin: 1.25rem auto 0 auto;
	line-height: 1.875rem;
	cursor: pointer;
}

.success-btn {
	width: 9.375rem;
	height: 1.875rem;
	text-align: center;
	line-height: 1.875rem;
	margin: 1.25rem auto 0 auto;
	background-color: #37a115;
	color: #ffffff;
	font-size: 14px;
	border-radius: 0.3125rem;
	cursor: pointer;
}

.soon-pay-btn {
	width: 13.0625rem;
	height: 3.125rem;
	text-align: center;
	line-height: 3.125rem;
	color: #ffffff;
	font-size: 18px;
	background-color: #d43737;
	margin-left: 2.6875rem;
	margin-top: 2.5rem;
	cursor: pointer;
}

.submit-box {
	width: 65.625rem;
	display: flex;
	justify-content: flex-end;
	margin-bottom: 3.125rem;
}

.pay-code {
	width: 9.375rem;
	height: 9.375rem;
	/* border: 1px solid #FF0000; */
	/* border-radius: 10px; */
	margin: 1.5rem auto 0 auto;
	overflow: hidden;
}

.paytype-item img:nth-of-type(1) {
	width: 5.75rem;
	margin-right: 1rem;
}

.paytype-item img:nth-of-type(2) {
	width: 3.4375rem;
	margin-right: 1rem;
}

.paytype-item img:nth-of-type(3) {
	width: 3.5625rem;
}

.paytype-item img {
	height: 1.125rem;
}

.paytype-item {
	display: flex;
	align-items: center;
	justify-content: center;
	margin-top: 0.875rem;
}

.pay-code-tips {
	margin-top: 1.875rem;
	color: #191919;
	font-size: 17px;
	text-align: center;
}

.pay-code-price span {
	color: #37a115;
	font-weight: bold;
	font-size: 2.125rem;
}

.pay-code-price {
	font-size: 24px;
	color: #191919;
	margin-top: 1.25rem;
	display: flex;
	justify-content: center;
	align-items: center;
}

.pay-code-top p:nth-of-type(2) {
	font-size: 28px;
	cursor: pointer;
}

.pay-code-top {
	display: flex;
	justify-content: space-between;
	align-items: center;
	color: #191919;
	font-size: 1rem;
}

.pay-code-content {
	width: 29.375rem;
	height: 27.5rem;
	background-color: #ffffff;
	border-radius: 0.625rem;
	border: 4px solid #b3b3b3;
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	padding: 0 0.4375rem;
}

.pay-code-box {
	width: 100%;
	height: 100%;
	position: fixed;
	top: 0;
	left: 0;
	background-color: rgba(0, 0, 0, 0.1);
	z-index: 10;
}

.pay-type-imgbox {
	margin-top: 15px;
}

.pay-type-imgbox img:nth-of-type(2) {
	margin: 0 1.25rem 0 1.25rem;
}

.pay-type-imgbox {
	display: flex;
	justify-content: center;
	align-items: center;
}

.pay-right-box p {
	color: #676767;
	font-size: 14px;
	font-weight: 400;
	text-align: center;
}

.pay-right-box {
	margin-left: 6.25rem;
}

.pay-type-box {
	display: flex;
	height: auto;
}
</style>

<script>
    import vueQr from "vue-qr"
    export default
    {
        name: 'userRecharge',
        props: { parentName: { type: Object } },
        data()
        {
            return {
                account: '',
                payFlagPapup: false,
                value: '',
                type: -1,
                set_value: -1,
                qr_text: "",
                userObj: {},
                myBalance: {},
                is_butClick: false,

                //+--------------------------------------------------------
                bol: false,
            };
        },
        components: {
            vueQr,
        },
        created()
        {
            this.init()
        },
        methods:
        {
            init() {
                this.userObj = JSON.parse( localStorage.getItem( 'loginData2' ) )

                let vipCard = localStorage.getItem( 'vipCard' )
                if ( vipCard && vipCard !== 'null' )
                {
                    this.account = vipCard
                }
                else
                {
                    this.account = localStorage.getItem( 'username' )
                }

                this.getBalance()
            },
            getBalance() {
                this.$api.order.UserBalances().then(res => {
                    if (res.data.code == 0) {
                        this.myBalance = res.data.result
                    } else {
                        let name = res.data.message
                        this.checkTips(name, "warning")
                    }
                })
            },
            valueClick(val) {
                this.value = ''
                this.set_value = -1

                if (this.set_value == val) return
                if (val == 1) {
                    this.set_value = 50
                } else if (val == 2) {
                    this.set_value = 100
                } else if (val == 3) {
                    this.set_value = 200
                }
                this.type = val
            },
            immediatePay() {
                if (this.set_value == -1 && !this.value) {
                    this.checkTips( "请选择或输入充值金额", 'warning' );
                    return
                }
                this.is_butClick = true
				this.$loading()
				let money = 0
				if (this.set_value > 0) {
					money = Number(this.set_value)
				} else {
					money = Number(this.value)
				}
				let params = {
					price: money
				}

				this.$api.order.UserRecharge(params).then(res => {
					this.$loading().close()
					if (res.data.code == 0) {
                        this.payFlagPapup = true
                        this.qr_text = res.data.result
					} else {
						let name = res.data.message
						this.checkTips(name, "warning")
					}
				})
            },
            pay_success() {
                this.payFlagPapup = false
                this.closeaddress(1)
            },
            checkTips( name, type )
            {
                this.$message(
                {
                    message: name,
                    type: type
                } );
            },
            closeCodePapup() {
                this.payFlagPapup = false
                this.is_butClick = false
            },
            // +--------------------------------------
            closeaddress(val)
            {
                this.$emit( 'childFn', val )
            }

        }
    }
</script>